module.exports = __webpack_public_path__ + "media/images/gallery/constellations/lacerta/lac_names-ea2cfcde711005650251bc12dd756534.gif";